import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../utils/UserContext';

const NavBar = () => {
    const { selectedWorkshop, workshops, setSelectedWorkshop, activeOrdersCount } = useContext(UserContext);
    const [workshopName, setWorkshopName] = useState('Ninguno');
    const navigate = useNavigate();

    const links = [
            { name: "Talleres", path: "/talleres", enabled: true },
            { name: "Ordenes", path: "/ordenes", enabled: !!selectedWorkshop },
            { name: "Clientes", path: "/clientes", enabled: !!selectedWorkshop },
            { name: "Personal", path: "/personal", enabled: !!selectedWorkshop },
            { name: "Proveedor", path: "/proveedor", enabled: !!selectedWorkshop },
        ];

    useEffect(() => {
        if (selectedWorkshop) {
            // Solo invalida el taller si la lista de talleres ya se cargó y no lo encuentra
            if (workshops.length > 0 && !workshops.find(t => t._id === selectedWorkshop._id)) {
                setSelectedWorkshop(null);
                setWorkshopName('Ninguno');
            } else {
                setWorkshopName(selectedWorkshop.name);
            }
        } else {
            setWorkshopName('Ninguno');
        }
    }, [selectedWorkshop, workshops, setSelectedWorkshop]);


    const handleSelectChange = (e) => {
        const id = e.target.value;
        if (!id) {
            setSelectedWorkshop(null);
            localStorage.removeItem('rol');
            setTimeout(() => navigate(links[0].path), 0);
            return;
        }
        const t = workshops.find(t => t._id === id);
        
        // Determinar el rol del usuario en este taller
        if (t) {
            const userID = localStorage.getItem('user_id');
            let userRole = '';
            
            if (t.owner_id === userID) {
                userRole = 'owner';
            } else if (t.admins && t.admins.includes(userID)) {
                userRole = 'Administrador';
            } else if (t.technicians && t.technicians.includes(userID)) {
                userRole = 'Técnico';
            }
            
            localStorage.setItem('rol', userRole);
        }
        
        setSelectedWorkshop(t || null);
        setTimeout(() => navigate(links[1].path), 0);
    };

    return (
        <div className="navbar">
            <span>
                Taller :
                <label>
                    <select value={selectedWorkshop?._id ?? ''} onChange={handleSelectChange}>
                        <option value="">Ninguno</option>
                        {workshops.map(t => (
                            <option key={t._id} value={t._id}>
                                {t.name}
                            </option>
                        ))}
                    </select>
                </label>

            </span>
        </div>
    );
};

export default NavBar;